import { Component, computed, inject, input } from '@angular/core';
import { Navigation } from '@core/navigation/navigation.model';
import { NavigationService } from '@core/navigation/navigation.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-navigation-module-icon',
  imports: [FontAwesomeModule],
  templateUrl: './navigation-module-icon.component.html',
  styleUrl: './navigation-module-icon.component.scss',
})
export class NavigationModuleIconComponent {
    Navigation = Navigation;
    
    navigationService = inject(NavigationService);

    moduleId = input<string>(undefined, {alias:'module-id'});
    highlight = input<boolean>(false);
    iconColour = input<string>('color--primary', {alias:'icon-colour-class'})

    moduleConfig = computed(() => {
        return this.navigationService.navigation().find((module) => module.id == this.moduleId())
    })

}
